import Account from '../../../../../services/account'
import Contact from './contact.vue';
import Auth from '../../../../../services/auth'
import { phone, cpfCnpj } from '../../../../../filters/string';

export default {
  props: ['company', 'contact'],
  data() {
    return {
      address: undefined,
      taxIdNumberFormatted: undefined,
      companyName: undefined,
      companyTradeName: undefined,
      cel:  undefined,
      tel:  undefined,
      email: undefined,
      error: false
    }
  },
  mounted() {
    // verificando se existe dados passados das props, caso exista ele preenche automaticamente
    if(this.company && this.contact) {
      this.companyName = this.company.companyName;
      this.companyTradeName =  this.company.companyTradeName;
      
      if(this.company.taxIdNumber) {
        this.taxIdNumberFormatted = cpfCnpj(this.company.taxIdNumber);
      }
      this.email = this.contact.email;
      this.cel = phone(`${this.contact.dddCellphone} ${this.contact.nroCellphone}`);  

      if(this.contact.nroPhone == 0 && this.contact.dddPhone == 0) {
        this.tel = '';
      } else {
        this.tel = phone(`${this.contact.dddPhone} ${this.contact.nroPhone}`);
      }
    }
  },
  methods: {
    clearData() {
      this.companyName = '';
      this.companyTradeName = '';
      this.email ='';
      this.cel = '';
      this.tel = '';
      this.address = '';
    },
    correctCursor2(a){
      if(!window.document.mobile)
        return;

      setTimeout(() => {
        $(a.target).val($(a.target).val());
      }, 80);
    },
    async companyExists() {

      if(!this.taxIdNumberFormatted) return;

      const cnpj = this.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();

      if(Auth.currentUser.taxIdNumber == cnpj ) {
        this.error = true;
        return;
      }
      this.error = false;

      const resp = await Account.getUserAndAddressByTaxIdNumberAggregate(cnpj);

      this.companyName = resp.user.company.companyName;
      this.companyTradeName = resp.user.company.companyTradeName;
      this.email = resp.user.email2;
      this.cel = phone(resp.user.dddCellphone + resp.user.nroCellphone);

      if(resp.user.nroPhone == 0 && resp.user.dddPhone == 0) {
        this.tel = '';
      } else {
        this.tel = phone(`${resp.user.dddPhone} ${resp.user.nroPhone}`);
      }

      this.address = resp.address;
    },
    validateAll(){
      return this.$validator.validateAll()
        .then( _ => {
          // passando os dados para o componente pai
          this.company.companyName = this.companyName;
          this.company.companyTradeName = this.companyTradeName;
          this.company.taxIdNumber = this.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
          this.contact.email = this.email;
           // formatando cel / tel
          this.contact.nroCellphone = Number(this.cel.substring(4, this.cel.length).replace('-', '').trim());
          this.contact.nroPhone = Number(this.tel.substring(4, this.cel.length).replace('-', '').trim());
          this.contact.dddCellphone = Number(this.cel.substring(0, 4).replace('(', '').replace(')', ''));
          this.contact.dddPhone = Number(this.tel.substring(0, 4).replace('(', '').replace(')', ''));
        }).then( _ => {
          if (this.address) {
            this.$emit('addressExists', this.address);
          }
        });
    }
  },
  components: {
    Contact
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/aggregate-register/company.js